import webClient from "../config/api.config";
import { SpecialtyPayloadVM } from "../types/specialty.definition";

export function requestGetSpecialties(lang: string = "fr") {
  return webClient.request({
    method: "get",
    url: `/specialties`,
    params: { lang },
  });
}

export function requestGetSpecialtyById(id: number, lang: string = "fr") {
  return webClient.request({
    method: "get",
    url: `/specialties/${id}`,
    params: { lang },
  });
}

export function requestCreateSpecialties(data: SpecialtyPayloadVM[]) {
  return webClient.request({
    method: "post",
    url: `/specialties`,
    data,
  });
}

export function requestUpdateSpecialty(id: number, data: SpecialtyPayloadVM) {
  return webClient.request({
    method: "put",
    url: `/specialties/${id}`,
    data,
  });
}

export function requestDeleteSpecialty(id: number) {
  return webClient.request({
    method: "delete",
    url: `/specialties/${id}`,
  });
}
